



































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import {
  IBookingSummaryData,
  IssuedStatusEnum,
  IDate,
  BookingStatusEnum,
} from '@/api/types';
import {
  ISearchBookingsRequest,
  ISearchBookingsResponse,
  searchBooking,
} from '@/api/booking';
import { AppModule } from '@/store/modules/app';
import { getParticipantName } from '@/utils/tickets';
import { sleep, stringToIDate, formatApiError } from '@/utils/index';

@Component({
  name: 'BookingSearchResult',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  @Prop({ required: false }) participantName?: string;
  @Prop({ required: false }) activityName?: string;
  @Prop({ required: false }) planName?: string;
  @Prop({ required: false }) purchaseDateRange?: string;
  @Prop({ required: false }) participationDateRange?: string;
  @Prop({ required: false }) statuses?: string;
  @Prop({ required: false }) bookingIdPrefix?: string;
  @Prop({ required: false }) supplierId?: string;
  @Prop({ default: '10' }) itemCount!: string;
  @Prop({ default: '1' }) page!: string;

  private currentItemCount: number = parseInt(this.itemCount, 10);
  private currentPage: number = parseInt(this.page, 10);
  private totalCount: number = 0;
  private bookings: (IBookingSummaryData & { participantName: string })[] = [];
  // uncomment if use server side paging
  // private filteredBookings: IBookingSummaryData[] = [];
  private searchConditions: { key: string; value: string }[] = [];
  private search = '';
  private loading = true;
  private tableOptions: any = {};

  get appLanguage() {
    return AppModule.language;
  }

  get translatedBookingHeaders() {
    return [
      { text: this.$t('Booking Id'), value: 'bookingId' },
      // {
      //   text: this.$t('Participant name'),
      //   value: 'participantName',
      // },
      {
        text: this.$t('Participant name'),
        value: 'participantName',
      },
      { text: this.$t('Activity name'), value: 'activityTitle' },
      { text: this.$t('Plan name'), value: 'planTitle' },
      { text: this.$t('Status'), value: 'issuedStatus' },
      { text: this.$t('Agent name'), value: 'agentName' },
    ];
  }

  // uncomment if use server side paging
  // @Watch('tableOptions')
  // onTableOptionsUpdated() {
  //   this.fetchDataWithServerPagination();
  // }

  // @Watch('search')
  // onFilter() {
  //   if (this.search) {
  //     this.filteredBookings = this.bookings.filter(
  //       (data: IBookingSummaryData) => {
  //         let hit = false;
  //         for (let header of this.bookingHeaders) {
  //           if (
  //             ((data as any)[header.value] as string).indexOf(this.search) >= 0
  //           ) {
  //             hit = true;
  //             break;
  //           }
  //         }
  //         return hit;
  //       }
  //     );
  //   } else {
  //     this.filteredBookings = this.bookings;
  //   }
  // }

  mounted() {
    this.fetchData();
  }

  @Watch('appLanguage')
  private onLangSelected() {
    this.updateBookingsParticipantName();
  }

  private async fetchData() {
    // AppModule.StartProgress();
    this.loading = true;
    const req = {} as ISearchBookingsRequest;
    let searchConditions: { key: string; value: string }[] = [];

    if (this.participantName) {
      req.participantName = this.participantName;
      searchConditions.push({
        key: 'Participant name',
        value: this.participantName,
      });
    }

    let purchaseDateRange: string[] = [];
    if (this.purchaseDateRange) {
      purchaseDateRange = JSON.parse(this.purchaseDateRange) as string[];
    }
    if (purchaseDateRange && purchaseDateRange.length == 2) {
      req.purchaseDateRange = {
        start: stringToIDate(purchaseDateRange[0]) as IDate,
        end: stringToIDate(purchaseDateRange[1]) as IDate,
      };
      searchConditions.push({
        key: 'Purchase date',
        value: `${purchaseDateRange[0]} ~ ${purchaseDateRange[1]}`,
      });
    }

    let participationDateRange: string[] = [];
    if (this.participationDateRange) {
      participationDateRange = JSON.parse(
        this.participationDateRange
      ) as string[];
    }
    if (participationDateRange && participationDateRange.length == 2) {
      req.participationDateRange = {
        start: stringToIDate(participationDateRange[0]) as IDate,
        end: stringToIDate(participationDateRange[1]) as IDate,
      };
      searchConditions.push({
        key: 'Participation date',
        value: `${participationDateRange[0]} ~ ${participationDateRange[1]}`,
      });
    }

    let statuses: IssuedStatusEnum[] = [];
    if (this.statuses) {
      statuses = JSON.parse(this.statuses) as IssuedStatusEnum[];
    }
    if (statuses && statuses.length > 0) {
      req.statuses = statuses;
      searchConditions.push({
        key: 'Status',
        value: this.statuses as string,
      });
    }

    if (this.activityName) {
      req.activityName = this.activityName;
      searchConditions.push({
        key: 'Activity name',
        value: this.activityName as string,
      });
    }

    if (this.planName) {
      req.planName = this.planName;
      searchConditions.push({
        key: 'Plan name',
        value: this.planName as string,
      });
    }

    if (this.bookingIdPrefix) {
      req.bookingIdPrefix = this.bookingIdPrefix;
      searchConditions.push({
        key: 'Booking Id',
        value: this.bookingIdPrefix as string,
      });
    }

    if (this.supplierId) {
      req.supplierId = this.supplierId;
      searchConditions.push({
        key: 'Supplier Id',
        value: this.supplierId as string,
      });
    }

    // uncomment if use server side paging
    // if (this.currentItemCount) {
    //   req.itemCount = this.currentItemCount;
    // }
    // if (this.currentPage) {
    //   req.page = this.currentPage;
    // }

    if (searchConditions.length <= 0) {
      this.$nextTick(() => {
        // if (AppModule.progress.active) {
        //   AppModule.StopProgress();
        // }
        this.loading = false;
      });

      return;
    }

    try {
      const res = await searchBooking(req);
      this.totalCount = res.totalCount;
      this.bookings = res.bookings as (IBookingSummaryData & {
        participantName: string;
      })[];
      this.updateBookingsParticipantName();
      // uncomment if use server side paging
      // this.onFilter();
      this.searchConditions = searchConditions;

      this.loading = false;
      // AppModule.StopProgress();
    } catch (err) {
      this.loading = false;
      // AppModule.StopProgress();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t(`@route.Booking search`) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private updateBookingsParticipantName() {
    this.bookings.forEach(b => {
      b.participantName = this.getParticipantName(
        b.participantFirstName,
        b.participantLastName
      );
    });
  }

  private async fetchDataWithServerPagination() {
    const { sortBy, descending, page, itemsPerPage } = this.tableOptions;
    this.currentItemCount = itemsPerPage;
    this.currentPage = page;
    await this.fetchData();
  }

  private getParticipantName(firstName: string, lastName: string) {
    return getParticipantName(firstName, lastName, AppModule.language);
  }

  private getStatusText(status: IssuedStatusEnum) {
    return (status as IssuedStatusEnum) === IssuedStatusEnum.DISABLE
      ? '-'
      : this.$t(`IssuedStatusEnum.${status}`);
  }

  private translateSearchConditionValue(searchCondition: {
    key: string;
    value: string;
  }) {
    if (searchCondition.key === 'Status') {
      const statuses = JSON.parse(searchCondition.value) as BookingStatusEnum[];
      const result = statuses.map(
        s => this.$t(`BookingStatusEnum.${s}`) as string
      );
      return JSON.stringify(result);
    }
    return searchCondition.value;
  }
}
